import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { Editor } from 'slate';
var InlineElementUtils = /*#__PURE__*/function () {
  function InlineElementUtils(editor) {
    var _this = this;
    _classCallCheck(this, InlineElementUtils);
    this.isLinkActive = function () {
      var _Editor$nodes = Editor.nodes(_this.editor, {
          match: {
            type: 'link'
          }
        }),
        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
        link = _Editor$nodes2[0];
      return !!link;
    };
    this.getLinkText = function (linkNode) {
      var linkText = '';
      linkNode.children.forEach(function (textNode) {
        linkText += textNode.text;
      });
      return linkText;
    };
    this.getCurrentLinkNode = function () {
      var _Editor$nodes3 = Editor.nodes(_this.editor, {
          match: {
            type: 'link'
          }
        }),
        _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
        link = _Editor$nodes4[0];
      if (link) {
        return link[0];
      }
      return null;
    };
    this.unwrapLink = function () {
      _this.editor.exec({
        type: 'unwrap_link'
      });
    };
    this.insertLink = function (elementData) {
      _this.editor.exec({
        type: 'insert_link_at_selection',
        elementData: elementData
      });
    };
    this.setLink = function (elementData) {
      _this.editor.exec({
        type: 'set_link',
        elementData: elementData
      });
    };
    this.insertImage = function (data) {
      _this.editor.exec({
        type: 'insert_image_at_selection',
        data: {
          src: data.url
        },
        at: data.selection
      });
    };
    this.isColumnActive = function () {
      var _Editor$nodes5 = Editor.nodes(_this.editor, {
          match: {
            type: 'column'
          }
        }),
        _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
        column = _Editor$nodes6[0];
      return !!column;
    };
    this.setSeatableColumn = function (data) {
      _this.editor.exec({
        type: 'set_seatable_column',
        data: data
      });
    };
    this.editor = editor;
  }
  _createClass(InlineElementUtils, [{
    key: "adjustImageSize",
    value: function adjustImageSize(options) {
      var data = Object.assign({}, {}, options);
      this.editor.exec({
        type: 'set_image',
        data: data
      });
    }
  }]);
  return InlineElementUtils;
}();
export default InlineElementUtils;